import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SessionService } from '../../Services/session.service';
import { EncryptionDecryptionService } from 'src/app/Services/encryption-decryption/encryption-decryption.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { WHStockInService } from 'src/app/Services/whstock-in/whstockin.service';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { PagerService } from 'src/app/Services/pager.service';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { element } from 'protractor';
import { WHSTockInDetails, Documents, DropDownResponse } from 'src/app/Models/WHStockIn/whstockin';
import { ToastrModule, ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-whstock-in',
  templateUrl: './whstock-in.component.html',
  styleUrls: ['./whstock-in.component.css'],
  providers: [PagerService, DatePipe]
})
export class WHStockInComponent implements OnInit {
  @ViewChild('jobnumber') jobnumber;
  @ViewChild('brand') brand;
  @ViewChild('crop') crop;
  @ViewChild('jobtype') jobtype;
  @ViewChild('language') language;
  @ViewChild('rmh') rmh;
  @ViewChild('requirementType') requirementType;
  @ViewChild('status') status;
  @ViewChild('po') po;
  @ViewChild('year') year;
  userName: string;
  roleCode: string;
  userID: string;
  roleID: string;
  CNNNumber: any;
  StockInDate: any;
  StockInQuantity: any;
  NumberofBoxes: any;
  Logistics: any;
  DocketNumber: any;
  InvoiceNumber: any;
  InvoiceDate: any;
  InvoiceValue: any;
  PaymentDate: any;
  Remarks: any;
  WHRemarks: any;
  POApprovedQty: any;
  selectedJobNumber: any = '';
  selectedRMHName: any = '';
  selectedJobType: any = '';
  selectedBrand: any = '';
  selectedCrop: any = '';
  selectedLanguage: any = '';
  selectedStatus: any = '';
  selectedPO: any = '';
  selectedRequirementType: any = '';
  details: WHSTockInDetails[] = [];

  displayToDoList: string = 'none';
  public ddlResponse: DropDownResponse = new DropDownResponse();
  displayPONumber: string = 'none';
  loader: string = 'none';
  path: string;
  displayPO: string = 'none';
  jobNumberr: any;
  poNumber: any;
  rmhName: string;
  approvedqty: any;
  files: File[] = [];
  rmhID: string;
  requirementSubmitted: number = 1;
  requirementApproved: number = 1;
  vendorFinalized: number = 0;
  poIssued: number = 0;
  artworkProductionApproved: number = 0;
  materialDispatch: number = 0;
  poDetails: any;
  processTimelineDetail: any;
  IsFileCorrect: boolean;
  pageSetting: number = 10;
  pager: any = {};
  model: any[];
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  RemainingQty:number;
  BalQty:number;
  Name: string;
  today:any;
  maxdate:any;
  IsSubmitDisable:boolean;
  IsSaveDisable:boolean;
  displayEditPanel: string = 'none';
  Date = new Date();
  public JobNumberSettings = {};
  public BrandSettings = {};
  public CropSettings = {};
  public JobTypeSettings = {};
  public LanguageSettings = {};
  public RMHSettings = {};
  public RequirementTypeSettings = {};
  public StatusSettings = {};
  public POSettings = {};
  yearSettings: IDropdownSettings={};
  document: Documents = new Documents();
  ascNumberSort: boolean = true;
  CurrentDate: string;
  sortDirection: string = '';
  @ViewChild('file') input;
  dropdownList = [
    { item_id: '1', item_text: 'Jan' },
    { item_id: '2', item_text: 'Feb' },
    { item_id: '3', item_text: 'Mar' },
    { item_id: '4', item_text: 'Apr' },
    { item_id: '5', item_text: 'May' },
    { item_id: '6', item_text: 'Jun' },
    { item_id: '7', item_text: 'Jul' },
    { item_id: '8', item_text: 'Aug' },
    { item_id: '9', item_text: 'Sep' },
    { item_id: '10', item_text: 'Oct' },
    { item_id: '11', item_text: 'Nov' },
    { item_id: '12', item_text: 'Dec' }

  ];

  constructor(private session: SessionService,
    private encryptionDecryptionService: EncryptionDecryptionService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private dialog: MatDialog, private wHStockInService: WHStockInService,
    private snackBar: MatSnackBarComponent, private _pagerService: PagerService,
    private datePipe: DatePipe,private toastr: ToastrService) {
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.userID = localStorage.getItem('mcmt_userId');
    this.CurrentDate = this.datePipe.transform(this.Date, 'MM/dd/yyyy');
    this.Name = localStorage.getItem('mcmt_userName');
  }
  ngOnInit(): void {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getFiltersOnPageLoad();
    this.JobNumberSetting();
    this.BrandSetting();
    this.CropSetting();
    this.LanguageSetting();
    this.StatusSetting();
    this.JobTypeSetting();
    this.RMHSetting();
    this.RequirementTypeSetting();
    this.POSetting();
    this.YearSettings();
    
    //this.today=new Date();
    //this.getsaveSubmitStatus();
    this.IsSubmitDisable=true;
    this.IsSaveDisable=true;

    
  }
  filter() {
    this.getDetailsOnFilter();
  }
  getsaveSubmitStatus() { 
    this.wHStockInService.getSaveSubmitStatus()
      .subscribe((resdata: any) => {
         if (resdata.status == 'IsSubmitSave') {
          this.IsSubmitDisable=true;
          this.IsSaveDisable=true;
        }
        else if(resdata.status == 'IsSubmit'){
          this.IsSubmitDisable=false;
          this.IsSaveDisable=true;
        }
        else if(resdata.status == 'IsSave'){
          this.IsSubmitDisable=true;
          this.IsSaveDisable=false;
        }
      })
  }
  getDetailsOnPageLoad() {
    let selectedYear = '';
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getWarehouseStockInDetails('', '', '', '', '', '', '', '', '',selectedYear)
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          this.details = resdata.data.warehouseStockInDetail;
          console.log(this.details);
          this.model = resdata.data.detail;
          //this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  getDetailsOnFilter() {
    let SelectedJobnumber = '';
    let SelectedRMH = '';
    let SelectedBrand = '';
    let SelectedCrop = '';
    let SelectedJobtype = '';
    let SelectedLanguage = '';
    let SelectedRequirementType = '';
    let SelectedStatus = '';
    let SelectedPO = '';
    let selectedYear = '';
    SelectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    SelectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    SelectedPO = Array.prototype.map.call(this.po.selectedItems, function (item) { return item.id; }).join(",");
    SelectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    SelectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    SelectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    SelectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
    SelectedLanguage = Array.prototype.map.call(this.language.selectedItems, function (item) { return item.id; }).join(",");
    SelectedRequirementType = Array.prototype.map.call(this.requirementType.selectedItems, function (item) { return item.id; }).join(",");
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getWarehouseStockInDetails(SelectedJobnumber, SelectedRMH, SelectedJobtype,
      SelectedBrand, SelectedCrop, SelectedRequirementType, SelectedLanguage,
      SelectedStatus, SelectedPO,selectedYear)
          .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          this.details = resdata.data.warehouseStockInDetail;
          this.model = resdata.data.detail;
          //this.setPage(1, this.pageSetting)
          //this.getsaveSubmitStatus();
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  viewPanel(JobNumber:any,POnumber: any) {
    let selectedYear = '';
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getWarehouseStockInDetails(JobNumber,'', '', '', '', '', '', '', POnumber,selectedYear)
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
         // this.details = resdata.data.warehouseStockInDetail;
          this.jobNumberr = resdata.data.warehouseStockInDetail[0].jobNumber;
          this.poNumber = resdata.data.warehouseStockInDetail[0].poNumber;
          this.rmhName = resdata.data.warehouseStockInDetail[0].rmhName;
          this.approvedqty = resdata.data.warehouseStockInDetail[0].quantity;
          this.CNNNumber=resdata.data.warehouseStockInDetail[0].cnNumber;
          this.StockInDate=new Date(resdata.data.warehouseStockInDetail[0].stockInDate);
          //this.StockInDate=resdata.data.warehouseStockInDetail[0].stockInDate;
          this.StockInQuantity=resdata.data.warehouseStockInDetail[0].stockInQty;
          this.NumberofBoxes=resdata.data.warehouseStockInDetail[0].noOfBoxes;
          this.Logistics=resdata.data.warehouseStockInDetail[0].logistics;
          this.DocketNumber=resdata.data.warehouseStockInDetail[0].docketNo;
          this.InvoiceNumber=resdata.data.warehouseStockInDetail[0].invoiceNo;
          this.InvoiceDate=resdata.data.warehouseStockInDetail[0].invoiceDate;
          this.InvoiceValue=resdata.data.warehouseStockInDetail[0].invoiceValue;
          this.PaymentDate=resdata.data.warehouseStockInDetail[0].paymentDate;
          this.Remarks=resdata.data.warehouseStockInDetail[0].remarks;
          this.WHRemarks=resdata.data.warehouseStockInDetail[0].whRemarks;
          this.POApprovedQty=resdata.data.warehouseStockInDetail[0].poApprovedQty;
          this.RemainingQty=this.approvedqty.replaceAll(',', '')-this.POApprovedQty.replaceAll(',','')
          
          if(Number(this.POApprovedQty)==Number(this.StockInQuantity))
          {
            this.BalQty=this.StockInQuantity.replaceAll(',','')
          }
         if(this.BalQty==0)
         {
          this.BalQty=this.POApprovedQty.replaceAll(',', '')-this.StockInQuantity.replaceAll(',','')
         }
         else
         {
          this.BalQty= this.StockInQuantity
         }
          if(resdata.data.warehouseStockInDetail[0].stockInDate=="" || resdata.data.warehouseStockInDetail[0].stockInDate==null)
          {
           // this.StockInDate =this.datePipe.transform(new Date(),"dd-MM-yyyy");
           this.StockInDate =new Date();
          }
          this.displayEditPanel = 'block';
         // this.getsaveSubmitStatus();
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  closeEditPanel() {
    this.displayEditPanel = 'none';
    let SelectedStatus;
    SelectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
    let SelectedYear;
    SelectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getWarehouseStockInDetails('', '', '',
      '', '', '', '','', '',SelectedYear)
          .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          this.details = resdata.data.warehouseStockInDetail;
          this.model = resdata.data.detail;
          //this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
      })
       // this.TotalRemainingQuantity = 0;
    // this.popTotalremainingqty = 0;
    // this.materialAllocation = [];
    // this.applySearchFilter();
  }
  ChangeRequest(Type:number)
  {
    
      this.wHStockInService.changeRequest(Type)
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          this.toastr.success(resdata.message);
          this.getDetailsOnPageLoad();
          //this.getsaveSubmitStatus();
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  
  }
  DraftSave(Type:number) {
    if(this.StockInDate.length==0)
    {
      this.toastr.error('Please Enter Stock In Date');
      return false;
    }
    if(this.StockInQuantity.length==0)
    {
      this.toastr.error('Please Enter Stock In Quantity');
      return false;
    }
    if(this.StockInQuantity==null ||this.StockInQuantity=="0")
    {
      this.toastr.error('Stock In Quantity cannot be 0');
      return false;
    }
    if(this.BalQty==0)
    {
      if(Number(this.StockInQuantity)>Number(this.POApprovedQty))
      this.toastr.error('Stock In Quantity cannot be greater than PO Approved Qty. ');
        return false;
     
    }
    else{
      if(Number(this.StockInQuantity)>this.BalQty)
      {
        this.toastr.error('Stock In Quantity cannot be greater than Remaining Quantity ');
        return false;
      }
    }
   
    let ConvertedStockInDate=this.datePipe.transform(this.StockInDate, 'dd-MMM-yyyy');
     this.wHStockInService.saveAsDraftStockInDetails(this.jobNumberr,this.StockInQuantity.replaceAll(',', ''),this.poNumber,ConvertedStockInDate,this.WHRemarks,Type)
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
         if(resdata.message=="Please Complete PO Update first.PO not done for complete Final Quantity.")
         {
          this.toastr.error(resdata.message);
         }
         else{
          this.toastr.success(resdata.message);
         }
          
          this.displayEditPanel = 'none';
          this.getDetailsOnFilter();
          this.loader = 'none';
        }
           else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }
  getFiltersOnPageLoad() {
    this.loader = 'block';
    this.wHStockInService.getFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          //this.dashboardFilters = resData.data as DashboardFilters;
          this.ddlResponse = resData.data;
          //this.ddlResponse.brands=resData.data;
          class YearItemList{
            id: string;
            text: string;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.ddlResponse.currentRequirementYear[0].currentrequirementYear,
            text: this.ddlResponse.currentRequirementYear[0].currentrequirementYear
          }
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem;
          this.getDetailsOnPageLoad();
          this.loader = 'none';
        }
        else {
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  onYearSelect(item: any) {
    let selectedyear = this.year.selectedItems[0].id;
    
    if(selectedyear != this.ddlResponse.currentRequirementYear[0].currentrequirementYear)
    {     
      var someElement= document.getElementById("ancUploadExcel"); 
      someElement.className += "hideuploadExcel";
    }
    else
    {
      document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
    }
  }

  ExcelDownload() {
    this.loader = 'block';
    let SelectedJobnumber = '';
    let SelectedRMH = '';
    let SelectedBrand = '';
    let SelectedCrop = '';
    let SelectedJobtype = '';
    let SelectedLanguage = '';
    let SelectedRequirementType = '';
    let SelectedStatus = '';
    let SelectedPO = '';
    let selectedYear = '';
    SelectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    SelectedRMH = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    SelectedPO = Array.prototype.map.call(this.po.selectedItems, function (item) { return item.id; }).join(",");
    SelectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    SelectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    SelectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    SelectedStatus = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
    SelectedLanguage = Array.prototype.map.call(this.language.selectedItems, function (item) { return item.id; }).join(",");
    SelectedRequirementType = Array.prototype.map.call(this.requirementType.selectedItems, function (item) { return item.id; }).join(",");
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.DownloadExcel(SelectedJobnumber, SelectedRMH, SelectedJobtype,
      SelectedBrand, SelectedCrop, SelectedRequirementType, SelectedLanguage,
      SelectedStatus, SelectedPO,selectedYear)
      .subscribe(
        success => {
          var date = new Date();
          let latest_date = this.datePipe.transform(date, 'dd-MMM-yy')
          let Name = localStorage.getItem('mcmt_userName').split(' ');
          let Firstname = Name[0];
          let LastName = Name[1];
          let cYear = this.year.selectedItems[0].id;
          let ExcelName = Firstname + '_' + LastName + '_'+ cYear + '_MaterialRecievedbyWarehouse_' + latest_date + '.xlsx';
          saveAs(success, ExcelName);
          this.loader = 'none';
        },
        err => {
          this.toastr.error("Some problem occurred while downloading file.");
          this.loader = 'none';
        }
      );
  }
  getJobnumberWiseData(filter: any) {
    this.loader = 'block';
    let selectedJobnumber = '';
    selectedJobnumber = Array.prototype.map.call(this.jobnumber.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getdataonjobnumberselection(selectedJobnumber, '', '', '')
      .subscribe((response) => {
        if (response.status) {
          this.jobnumber.selectedItems = response.data.selectedjobnumber.map(item => { return { id: item.jobNumber, text: item.jobNumber } });
          this.brand.selectedItems = response.data.brands.map(item => { return { id: item.brandID, text: item.brandName } });
          this.crop.selectedItems = response.data.crops.map(item => { return { id: item.cropID, text: item.cropName } });
          this.jobtype.selectedItems = response.data.jobTypes.map(item => { return { id: item.jobTypeID, text: item.jobTypeName } });
          this.language.selectedItems = response.data.languages.map(item => { return { id: item.languageID, text: item.languageName } });
          this.rmh.selectedItems = response.data.rmhs.map(item => { return { id: item.rMHCode, text: item.rMHName } });
          this.po.selectedItems = response.data.po.map(item => { return { id: item.poNumber, text: item.poNumber } });
          this.requirementType.selectedItems = response.data.requirementTypes.map(item => { return { id: item.requirementTypeID, text: item.requirementTypeName } });
          //this.status.selectedItems = response.data.status.map(item => { return { id: item.requirementStatusID, text: item.requirementStatusName } });
          this.loader = 'none';

        }

      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  getBrandWiseData(filter: any) {
    this.loader = 'block';
    let selectedBrand = '';
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getdataonjobnumberselection('', '', selectedBrand, '')
      .subscribe((response) => {
        if (response.status) {
          this.brand.selectedItems = response.data.brands.map(item => { return { id: item.brandID, text: item.brandName } });
          this.crop.selectedItems = response.data.crops.map(item => { return { id: item.cropID, text: item.cropName } });
          this.jobtype.selectedItems = response.data.jobTypes.map(item => { return { id: item.jobTypeID, text: item.jobTypeName } });
          this.language.selectedItems = response.data.languages.map(item => { return { id: item.languageID, text: item.languageName } });
          this.loader = 'none';

        }

      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  getPOWiseData(filter: any) {
    this.loader = 'block';
    let selectedPO = '';
    selectedPO = Array.prototype.map.call(this.po.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getdataonjobnumberselection('', '', '', selectedPO)
      .subscribe((response) => {
        if (response.status) {
          this.jobnumber.selectedItems = response.data.selectedjobnumber.map(item => { return { id: item.jobNumber, text: item.jobNumber } });
          this.brand.selectedItems = response.data.brands.map(item => { return { id: item.brandID, text: item.brandName } });
          this.crop.selectedItems = response.data.crops.map(item => { return { id: item.cropID, text: item.cropName } });
          this.jobtype.selectedItems = response.data.jobTypes.map(item => { return { id: item.jobTypeID, text: item.jobTypeName } });
          this.language.selectedItems = response.data.languages.map(item => { return { id: item.languageID, text: item.languageName } });
          this.rmh.selectedItems = response.data.rmhs.map(item => { return { id: item.rMHCode, text: item.rMHName } });
          this.po.selectedItems = response.data.po.map(item => { return { id: item.poNumber, text: item.poNumber } });
          this.requirementType.selectedItems = response.data.requirementTypes.map(item => { return { id: item.requirementTypeID, text: item.requirementTypeName } });
          //this.status.selectedItems = response.data.status.map(item => { return { id: item.requirementStatusID, text: item.requirementStatusName } });
          this.loader = 'none';

        }

      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  filesDroppedAdd(files: File[]) {
    this.loader = 'block';
    this.files = [];
    this.files = files;
     let fileNameParts: string[] = files[0].name.split('.');
     let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    // let Name = localStorage.getItem('mcmt_userName').split(' ');
    // let Firstname = Name[0];
    // let LastName = Name[1];
    //let CorrectFileName = Firstname + '_' + LastName + '_MaterialRecievedbyWarehouse_'
    // let CorrectFileName = '_MaterialRecievedbyWarehouse_'
    // if (fileNameParts[1].includes(CorrectFileName)) {
    //   this.IsFileCorrect = true;
    // }
    // else {
    //   this.IsFileCorrect = false;
    // }
    // if (this.IsFileCorrect == false) {
    //   this.toastr.error('Please select a valid file.', 'Close', 'red-snackbar');
    //   this.loader = 'none';
    //   this.input.nativeElement.value = null;
    //   return false;
   // }
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please select valid file type.');
      this.loader = 'none';
      this.input.nativeElement.value = null;
      return false;
    }

    //this.loader = 'block';
    this.document.file = <File>this.files[0];
    //this.document.UploadedBy = localStorage.getItem('userId');
    this.wHStockInService.uploadDocument(this.document.file)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.toastr.success(resData.message);
          //this.loader = 'none';
          this.getDetailsOnPageLoad();
          //this.getsaveSubmitStatus() ;
        } else {
          this.toastr.error(resData.message);
          //this.loader = 'none';
          this.getDetailsOnPageLoad();
          //this.getsaveSubmitStatus() ;
        }
        // this.getDocuments();
        // this.displayUpload = 'none';
        this.files = [];
        this.input.nativeElement.value = null;
        this.loader = 'none';
      });
    this.files = files;
    //this.fileName = files[0].name;

  }
  JobNumberSetting() {
    this.JobNumberSettings = {
      singleSelection: false,
      idField: 'jobNumber',
      textField: 'jobNumber',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No jobNumbers Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  onJobNumberSelect(item: any) {
    this.getJobnumberWiseData(this.jobnumber.selectedItems);
  }
  onJobNumberSelectAll(item: any) {
    this.getJobnumberWiseData(this.jobnumber.selectedItems);
  }
  onJobNumberDeSelect(item: any) {
    this.getJobnumberWiseData(this.jobnumber.selectedItems);
    if (this.jobnumber.selectedItems.length == 0) {
      this.jobnumber.selectedItems = [];
      this.brand.selectedItems = [];
      this.crop.selectedItems = [];
      this.jobtype.selectedItems = [];
      this.language.selectedItems = [];
      this.rmh.selectedItems = [];
      this.po.selectedItems = [];
      this.requirementType.selectedItems = [];
      this.status.selectedItems = [];
    }
  }
  onJobNumberDeSelectAll(item: any) {
    let SelectedYear = '';
    SelectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getWarehouseStockInDetails('', '', '', '', '', '', '', '', '',SelectedYear)
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          this.details = resdata.data.warehouseStockInDetail;
          this.model = resdata.data.detail;
          //this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
    this.jobnumber.selectedItems = [];
    this.brand.selectedItems = [];
    this.crop.selectedItems = [];
    this.jobtype.selectedItems = [];
    this.language.selectedItems = [];
    this.rmh.selectedItems = [];
    this.po.selectedItems = [];
    this.requirementType.selectedItems = [];
    this.status.selectedItems = [];

  }
  onPOSelect(item: any) {
    this.getPOWiseData(this.po.selectedItems);

  }
  onPOSelectAll(item: any) {
    this.getPOWiseData(this.po.selectedItems);

  }
  onPODeSelect(item: any) {
    this.getPOWiseData(this.po.selectedItems);
    if (this.po.selectedItems.length == 0) {
      this.jobnumber.selectedItems = [];
      this.brand.selectedItems = [];
      this.crop.selectedItems = [];
      this.jobtype.selectedItems = [];
      this.language.selectedItems = [];
      this.rmh.selectedItems = [];
      this.po.selectedItems = [];
      this.requirementType.selectedItems = [];
      this.status.selectedItems = [];
    }
  }
  onPODeSelectAll(item: any) {
    let SelectedYear = '';
    SelectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.wHStockInService.getWarehouseStockInDetails('', '', '', '', '', '', '', '', '',SelectedYear)
      .subscribe((resdata: any) => {
        this.loader = 'block';
        if (resdata.status == true) {
          this.details = resdata.data.warehouseStockInDetail;
          this.model = resdata.data.detail;
          //this.setPage(1, this.pageSetting)
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
    this.jobnumber.selectedItems = [];
    this.brand.selectedItems = [];
    this.crop.selectedItems = [];
    this.jobtype.selectedItems = [];
    this.language.selectedItems = [];
    this.rmh.selectedItems = [];
    this.po.selectedItems = [];
    this.requirementType.selectedItems = [];
    this.status.selectedItems = [];
  }
  onRMHSelect(item: any) {

    // this.GetRMHWiseData(this.rmh.selectedItems);

  }
  onRMHSelectAll(item: any) {
    // this.GetRMHWiseData(this.rmh.selectedItems);

  }

  onRMHDeSelect(item: any) {
    //this.language.selectedItems = [];
  }
  onRMHDeSelectAll(item: any) {

    //this.language.selectedItems = [];
  }
  onbrandSelect(item: any) {
    this.getBrandWiseData(this.brand.selectedItems);
  }
  onbrandSelectAll(item: any) {
    this.getBrandWiseData(this.brand.selectedItems);
  }
  onbrandDeSelect(item: any) {
    if (this.brand.selectedItems.length < 1) {
      this.brand.selectedItems = [];
      this.crop.selectedItems = [];
      this.jobtype.selectedItems = [];
      this.language.selectedItems = [];
    }
    else
      this.getBrandWiseData(this.brand.selectedItems);
  }
  onbrandDeSelectAll(item: any) {
    this.brand.selectedItems = [];
    this.crop.selectedItems = [];
    this.jobtype.selectedItems = [];
    this.language.selectedItems = [];
  }
  BrandSetting() {
    this.BrandSettings = {
      singleSelection: false,
      idField: 'brandID',
      textField: 'brandName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Brand Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  CropSetting() {
    this.CropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Crop Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  JobTypeSetting() {
    this.JobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No JobType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  LanguageSetting() {
    this.LanguageSettings = {
      singleSelection: false,
      idField: 'languageID',
      textField: 'languageName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Language Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RMHSetting() {
    this.RMHSettings = {
      singleSelection: false,
      idField: 'rMHCode',
      textField: 'rMHName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RMH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RequirementTypeSetting() {
    this.RequirementTypeSettings = {
      singleSelection: false,
      idField: 'requirementTypeID',
      textField: 'requirementTypeName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RequirementType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  YearSettings(){
    this.yearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  POSetting() {
    this.POSettings = {
      singleSelection: false,
      idField: 'poNumber',
      textField: 'poNumber',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RequirementType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  StatusSetting() {
    this.StatusSettings = {
      singleSelection: false,
      idField: 'requirementStatusID',
      textField: 'requirementStatusName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Status Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  ConvertToCurrency(value:any)
  {
    var parts = value.toString().replace(',','').split(".");
    if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
    }
    return parts.join(".");
  }
}

